import React from "react";
import "./styles/RefreshTimer.css";

/**
 * Countdown ring for the 60s auto-refresh, driven by App's tick.
 * Paused states render a static "paused" ring (no animation).
 */
export default function RefreshTimer({ secondsLeft, total = 60, paused, pausedReason }) {
  const pct = Math.max(0, Math.min(1, secondsLeft / total));
  const r = 9;
  const c = 2 * Math.PI * r;

  return (
    <div
      className="refresh-timer"
      title={
        paused
          ? `Auto-refresh paused${pausedReason ? ` (${pausedReason})` : ""}`
          : `Next refresh in ${Math.ceil(secondsLeft)}s`
      }
    >
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
        <circle cx="11" cy="11" r={r} className="ring-track" />
        <circle
          cx="11"
          cy="11"
          r={r}
          className={`ring-progress ${paused ? "ring-paused" : ""}`}
          strokeDasharray={c}
          strokeDashoffset={c * (1 - pct)}
        />
      </svg>
      <span className="refresh-label mono">
        {paused ? "⏸" : `${Math.ceil(secondsLeft)}s`}
      </span>
    </div>
  );
}
